module.exports = __webpack_public_path__ + "static/media/netherlands.ebcd669e.svg";